module.exports = __webpack_public_path__ + "img/file---------------@1x.54d517da.png";